import axios from 'axios';
import {globalActions} from '../store/global-actions';

function initListingStatisticsComponent(app) {
    app.component('listing-statistics', {
        template: '#listing-statistics',
        props: {
            listingId: {},
            loadData: {},
            label: {},
            buttonClasses: {},
            filterViewsUrl: {},
            moreStatsUrl: {},
        },
        data() {
            return {
                showOwnAndAdminViews: true,
                allViewsData: null,
                filteredViewsData: null,
            };
        },
        methods: {
            filterViews() {
                if (!this.showOwnAndAdminViews && (this.filteredViewsData == null)) {
                    this.getViewsData(true, (data) => this.filteredViewsData = data);
                }
            },

            getStatistics() {
                if (!this.loadData) {
                    globalActions.openBoostModal();
                    return;
                }
                if (this.allViewsData == null) {
                    this.showOwnAndAdminViews = true;

                    this.getViewsData(false, (data) => this.allViewsData = data);
                }
            },

            getViewsData(showFilteredStats, callback) {
                axios.get(this.filterViewsUrl, {
                    params: {
                        id: this.listingId,
                        showFilteredStats,
                    },
                })
                    .then((response) => {
                        callback(response.data);
                    });
            },

            close() {
                this.$refs.statsDropdown.close();
            },
        },
    });

    app.component('listing-card-engage-statistics', {
        template: '#listing-card-engage-statistics',
        props: {
            statsUrl: {},
            featuredStatusName: {},
        },
        data() {
            return {
                stats: {},
            };
        },
        methods: {
            getStats() {
                axios.get(this.statsUrl)
                    .then((response) => {
                        this.stats = response.data;
                    });
            },
        },
        mounted() {
            this.getStats();
        },
    });
}

export default initListingStatisticsComponent;
